export enum JobAttachmentType {
    Image = 'image',
    Reports = 'reports',
    Exports = 'exports',
    ReportsAndExports = 'reportsAndExports',
    Other = 'other'
}

export enum JobAttachmentChipType {
    Tag = 'tag',
    Report = 'report',
    LinkedProjectData = 'linkedProjectData',
    Other = 'other',
    EditLinkedProjectData = 'editLinkedProjectData'
}

export enum JobAttachmentTag {
    Report = 'Report',
    Export = 'Export',
    FieldGenerated = 'FieldGenerated',
    RootDataFile = 'RootDataFile', // job file
    RootDataFileJxl = 'RootDataFileJxl', // jxl file
    Media = 'Media'
}
